const PERIOD_LABELS = {
  Week: 'Current week',
  LastWeek: 'Last week',
  Month: 'Current month',
  LastMonth: 'Last month',
  Quarter: 'Current quarter',
  LastQuarter: 'Last quarter',
  Year: 'Current year',
  LastYear: 'Last year',
};

export const ALL_PARTNER_COMPANIES = 'All Partner Companies';

const PARTNER_EXPORT_BASE = {
  drawerTitle: 'Export Partner Analytics',
  dashboardTitle: 'Partner Analytics Export',
  fileNamePrefix: 'partner-analytics',
  imageFilePrefix: 'partner',
  imageZipFileName: 'partner-analytics-images.zip',
  filterFields: [
    { key: 'period', label: 'Period' },
    { key: 'partnerCompany', label: 'Partner Company' },
  ],
};

export const PARTNER_AGGREGATE_EXPORT_CONFIG = {
  ...PARTNER_EXPORT_BASE,
  sections: [
    {
      title: 'Overview',
      items: [
        { id: 'export-partner-kpi-summary', label: 'Partner KPI Summary' },
        { id: 'export-partner-regional-overview', label: 'Partner Regional Overview' },
      ],
    },
    {
      title: 'Narrative Usage',
      items: [
        { id: 'export-partner-top-narratives', label: 'Top Narratives Used by Partners' },
        { id: 'export-partner-usage-trend', label: 'Partner Narrative Usage Trend' },
        {
          id: 'export-partner-company-breakdown',
          label: 'Partner Company Narrative Breakdown',
        },
        {
          id: 'export-partner-regional-narrative-breakdown',
          label: 'Partner Regional Narrative Breakdown',
        },
      ],
    },
    {
      title: 'Bookings',
      items: [
        { id: 'export-partner-booking-trend', label: 'Partner Booking Volume Trend' },
      ],
    },
    {
      title: 'Ingestion / Type',
      items: [
        {
          id: 'export-partner-ingestion-overview',
          label: 'Partner Regional Ingestion Type Overview',
        },
      ],
    },
  ],
};

export const buildPartnerCompanyExportConfig = (companyName) => ({
  ...PARTNER_EXPORT_BASE,
  sections: [
    {
      title: 'Overview',
      items: [
        { id: 'export-partner-company-kpi-summary', label: `${companyName} KPI Summary` },
      ],
    },
    {
      title: 'Narrative Usage',
      items: [
        {
          id: 'export-partner-company-top-narratives',
          label: `Top Narratives Used by ${companyName}`,
        },
        {
          id: 'export-partner-company-narrative-trend',
          label: `${companyName} Narrative Usage Trend`,
        },
        {
          id: 'export-partner-company-user-narrative-breakdown',
          label: `${companyName} User Narrative Run Breakdown`,
        },
      ],
    },
    {
      title: 'Bookings',
      items: [
        {
          id: 'export-partner-company-booking-trend',
          label: `${companyName} Booking Volume Trend`,
        },
        {
          id: 'export-partner-company-user-booking-breakdown',
          label: `${companyName} User Booking Breakdown`,
        },
      ],
    },
    {
      title: 'Ingestion / Type',
      items: [
        {
          id: 'export-partner-company-ingestion',
          label: `${companyName} Ingestion Type Overview`,
        },
      ],
    },
  ],
});

export const getPartnerExportConfig = (selectedPartnerCompany) => {
  if (selectedPartnerCompany === ALL_PARTNER_COMPANIES) {
    return PARTNER_AGGREGATE_EXPORT_CONFIG;
  }

  return buildPartnerCompanyExportConfig(selectedPartnerCompany);
};

export const getPartnerPeriodLabel = (period) => PERIOD_LABELS[period] || period;

export { buildFilterSummary, getExportItemIds, getExportItemsById } from './exportConfigUtils';
